// Centralized JSON-LD constants for consistent structured data across the site.
// Review data (rating, total count, stored review texts) lives in ONE editable
// source: src/data/reviews.json. Update that file whenever the Google Business
// Profile review count or rating changes - the site schema, <ReviewsHighlight />
// and the get_reviews MCP tool all read from it.

import reviewsData from "@/data/reviews.json";

export const BUSINESS_NAME = "Avolus Cars";
export const SCHEMA_BUSINESS_NAME = "Avolus Luxury Car Rental";
export const LEGAL_NAME = "1590976 B.C. LTD.";
// Branded 1200x630 share image served from /public.
export const OG_IMAGE_URL = "https://avoluscars.com/og-image.jpg";
export const BUSINESS_URL = "https://avoluscars.com";
export const BUSINESS_TELEPHONE = "+1-778-379-8881";
export const BUSINESS_EMAIL = "info@avoluscars.com";

export const REVIEW_COUNT = reviewsData.reviewCount;
export const RATING_VALUE = reviewsData.ratingValue;

export const SAME_AS: string[] = [
  "https://instagram.com/avoluscars",
  "https://facebook.com/avoluscars",
  // Google Business Profile
  "https://maps.app.goo.gl/93x1Nm23SS2p5cAP8",
];

// Google Business Profile - visible link on every review widget.
export const GOOGLE_BUSINESS_URL = reviewsData.googleBusinessUrl;

// Featured reviews (real Google reviews, first name + last initial).
export type FeaturedReview = {
  author: string;         // "Zhi Kin H."
  fullAuthor: string;     // For JSON-LD schema author.name
  rating: number;         // 1-5
  datePublished: string;  // ISO 8601
  body: string;
  reviewUri?: string | null;  // Google Maps link that opens this exact review
};

export const FEATURED_REVIEWS: FeaturedReview[] = reviewsData.reviews;




export type Crumb = { name: string; url: string };

export const breadcrumbList = (items: Crumb[]) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
    item: it.url,
  })),
});

export const breadcrumbScript = (items: Crumb[]) => ({
  type: "application/ld+json",
  children: JSON.stringify(breadcrumbList(items)),
});

export type FaqItem = { question: string; answer: string };

export const faqPage = (items: FaqItem[]) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: items.map((it) => ({
    "@type": "Question",
    name: it.question,
    acceptedAnswer: {
      "@type": "Answer",
      text: it.answer,
    },
  })),
});

export const faqScript = (items: FaqItem[]) => ({
  type: "application/ld+json",
  children: JSON.stringify(faqPage(items)),
});
